export default __webpack_public_path__ + "static/media/logo-filled.9baf6fb8.jpg";